import apiConfig from "../../config/apiConfig";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { CART_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchCarts = (cart_key) =>
   async (dispatch) => {
      const params = {
         cart_key
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.SHOPPING_CARTS}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: CART_TYPE.FETCH,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const changeQuantity = (id, quantity) =>
   async (dispatch, getState) => {
      const { carts } = getState();
      let data = carts?.cartItems?.find((f) => f.item_key == id);
      data.quantity = quantity;
      dispatch(showLoading());
      apiConfig.post(END_POINT.SHOPPING_CART_ITEMS, data).then((response) => {
         dispatch({
            type: CART_TYPE.CHANGE_QUANTITY,
            payload: {
               data: {
                  ...data,
                  ...response.data
               },
               id: id
            }
         })
      }).catch((error) => {
         dispatch(setError(error.message))
      }).finally(() => {
         dispatch(hideLoading());
      });

   }

export const changeValue = (key, value) =>
   async (dispatch) => {
      dispatch({
         type: CART_TYPE.CHANGE_VALUE,
         payload: {
            key,
            value
         }
      })
   }

export const submitCart = (carts, callback) =>
   async (dispatch) => {
      dispatch(showLoading());
      apiConfig.post(END_POINT.SHOPPING_CART_SUBMIT, carts).then((response) => {
         if (callback) {
            callback(response.data);
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

